<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/llsyJL/tc-custom/9781426841996.jpg?1705026343087" alt="This image is the cover for the book One-Night Wife, The O'Connells"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">One-Night Wife, The O'Connells
      </h1>
      <p class="bookDescription body article font2">
        <i>The bride-to-be...</i><br/><br/>Penniless Savannah knows that to help her sick little sister she has to win big at the casino.<br/><br/><i>The groom...</i><br/><br/>But Sean O'Connell always plays to win...<br/><br/><i>The indecent proposal...</i><br/><br/>Virgin Savannah is no match for Sean and soon she's lost everything! Sean offers her one last gamble: he'll settle her debts if she becomes his wife...for just one night!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sandra Marton
      </h2>
      
      <p class="authorDescription body article">Sandra Marton is a USA Todday Bestselling Author. A four-time finalist for the RITA, the coveted award given by Romance Writers of America, she&#39;s also won eight Romantic Times &#160;Reviewers&rsquo; Choice Awards, the Holt Medallion, and Romantic Times&rsquo; Career Achievement Award. Sandra&#39;s heroes are powerful, sexy, take-charge men who think they have it all--until that one special woman comes along. Stand back, because together they&#39;re bound to set the world on fire.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?517d4fac